export const enum FeatureAdoptionTypes {
  ScalePrinted = 1,
  handoff,
}
export interface FeatureAdoptionData {
  type: FeatureAdoptionTypes;
  views: number;
  lastShown: string;
}
